import React, { useEffect } from "react";
import { Module } from "../types/Module";
import { Button, OverlayTrigger, Table, Popover } from "react-bootstrap";
import "../styles/EmployeeList.css";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { Edit, Trash } from "react-feather";
import { AppDispatch } from "../redux/store";
import { fetchModules } from "../redux/actions/moduleAction";
import { fetchProjects } from "../redux/actions/projectAction";

interface Props {
  modules: Module[];
  onEdit: (module: Module) => void;
  onDelete: (id: number) => void;
}

const ModuleList: React.FC<Props> = ({ modules, onEdit, onDelete }) => {
  const dispatch = useDispatch<AppDispatch>();

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete details</Popover.Body>
    </Popover>
  );
  const projects = useSelector((state: StoreState) => state.project);

  useEffect(() => {
    dispatch(fetchModules());
  }, []);

  useEffect(() => {
    dispatch(fetchProjects());
  }, []);

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Project</th>
          <th>Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {modules.map((mod, index) => {
          const project = projects.find(
            (p) => Number(p.id) === Number(mod.projectId),
          );
          const projectName = project?.name;

          return (
            <tr key={mod.id}>
              <td>{index + 1}</td>
              <td>{projectName}</td>
              <td>{mod.name}</td>
              <td className="d-flex no-wrap border-0 justify-content-center">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    variant="warning"
                    className="mr-2"
                    onClick={() => onEdit(mod)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                {/* <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    variant="danger"
                    onClick={() => onDelete(mod.id)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Trash />
                  </Button>
                </OverlayTrigger> */}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default ModuleList;
